import WithRender from "../../templates/containers/pageOptionContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductPageOptions", "getSelector"])
  },
  props: ["hideContainer"]
});
